import StorageIcon from "@mui/icons-material/Storage";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import type { SvgIconComponent } from "@mui/icons-material";

/**
 * Email action types available for admin actions
 */
export type EmailActionType = "storeEmailInS3" | "addToTestSet" | "copyTestFixture" | "createWorkflowEntity";

/**
 * Definition for an email admin action
 */
export interface EmailActionDefinition {
  id: EmailActionType;
  label: string;
  description: string;
  icon: SvgIconComponent;
  supportsBatch: boolean;
  requiresDialog: boolean;
}

/**
 * All available email admin actions
 * This is the single source of truth for action definitions
 */
export const EMAIL_ACTIONS: Record<EmailActionType, EmailActionDefinition> = {
  storeEmailInS3: {
    id: "storeEmailInS3",
    label: "Store in S3",
    description: "Store email content in S3 for permanent storage",
    icon: StorageIcon,
    supportsBatch: true,
    requiresDialog: false,
  },
  addToTestSet: {
    id: "addToTestSet",
    label: "Add to Test Set",
    description: "Add email(s) to a test set for testing email automation",
    icon: PlaylistAddIcon,
    supportsBatch: true,
    requiresDialog: true,
  },
  copyTestFixture: {
    id: "copyTestFixture",
    label: "Copy Test Fixture",
    description: "Generate and copy a test fixture to clipboard",
    icon: ContentCopyIcon,
    supportsBatch: false,
    requiresDialog: false,
  },
  createWorkflowEntity: {
    id: "createWorkflowEntity",
    label: "Create Workflow Entity",
    description: "Create an EmailWorkflowProcessedEntity for backfill processing",
    icon: PlayArrowIcon,
    supportsBatch: true,
    requiresDialog: true,
  },
};

/**
 * Get all actions as an array
 */
export function getAllActions(): EmailActionDefinition[] {
  return Object.values(EMAIL_ACTIONS);
}

/**
 * Get batchable actions only
 */
export function getBatchableActions(): EmailActionDefinition[] {
  return getAllActions().filter((action) => action.supportsBatch);
}

/**
 * Get action by ID
 */
export function getAction(id: EmailActionType): EmailActionDefinition {
  return EMAIL_ACTIONS[id];
}
